import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGiftCardsinline = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 64 64",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		strokeLinejoin: "round",
		children: [
			/* @__PURE__ */ _jsx("path", {
				stroke: "#000",
				strokeWidth: 2,
				d: "M8.09545898 14.996582L9.70323849 10.765012C10.3859 8.66399598 12.6425165 7.51419244 14.7435325 8.19685393L38.095459 14.996582M55.0300126 22L58.5293257 23.1369958C60.6303418 23.8196573 61.7801453 26.0762738 61.0974838 28.1772898L55 46.9434153"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 52,
				height: 38,
				x: 3,
				y: 15,
				stroke: "#000",
				strokeLinecap: "square",
				strokeWidth: 2,
				rx: 4
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#000",
				strokeLinecap: "square",
				strokeWidth: 2,
				d: "M24,39 L18,33",
				transform: "matrix(-1 0 0 1 42 0)"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#000",
				strokeLinecap: "square",
				strokeWidth: 2,
				d: "M30,39 L24,33"
			}),
			/* @__PURE__ */ _jsx("polygon", {
				stroke: "#000",
				strokeLinecap: "square",
				strokeWidth: 2,
				points: "14 25.999 24 23 24 35 14 32.001",
				transform: "matrix(-1 0 0 1 38 0)"
			}),
			/* @__PURE__ */ _jsx("polygon", {
				stroke: "#000",
				strokeLinecap: "square",
				strokeWidth: 2,
				points: "24 25.999 34 23 34 35 24 32.001"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#000",
				strokeLinecap: "square",
				strokeWidth: 2,
				d: "M3.25,29 L13.25,29",
				transform: "matrix(1 0 0 -1 0 58)"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#000",
				strokeLinecap: "square",
				strokeWidth: 2,
				d: "M24,53 L24,16",
				transform: "matrix(1 0 0 -1 0 69)"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#000",
				strokeLinecap: "square",
				strokeWidth: 2,
				d: "M35,29 L54,29",
				transform: "matrix(1 0 0 -1 0 58)"
			})
		]
	})
});
export default SvgGiftCardsinline;
